import { Controller } from 'stimulus';
import StimulusReflex from 'stimulus_reflex';
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { Eng } from "flatpickr/dist/l10n/default.js"
import { v4 as uuidv4 } from 'uuid';

export default class extends Controller {
  connect() {
    StimulusReflex.register(this);
    this.element[this.identifier] = this; // element.controllerName anywhere you need it.
    this._handleErrorMessage = this._handleErrorMessage.bind(this);
    document.addEventListener('reflex:error_message', this._handleErrorMessage);
  }

  disconnect() {
    super.disconnect();
    document.removeEventListener('reflex:error_message', this._handleErrorMessage);
    this.removeDocumentListeners();
  }

  initialize() {
    this.documentReady(this.
    showTimesAndDatesInLocalZone.bind(this));
    this.listeners = [];
  }

  documentReady(callback) {
    // in case the document is already rendered
    if (document.readyState != 'loading') {
      callback();
      document.addEventListener('DOMContentLoaded', callback);
    }
    // modern browsers
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
    // IE <= 8
    else document.attachEvent('onreadystatechange', function () {
      if (document.readyState == 'complete') callback();
    });
  }

  getLocale() {
    let locale = document.querySelector('#locale')
    if (locale == 'en') {
      locale = Eng;
    } else {
      locale = Czech;
    }
    return locale;
  }

  appendLog(message) {
    console.log(message);

    var text = document.createTextNode(message + "\n");
    if (this.hasLogdstTarget) {
      this.logdstTarget.appendChild(text);
      this.logdstTarget.scrollTop = this.logdstTarget.scrollHeight;
    }
  }

  setRequestId() {
    this.requestId = uuidv4();
    document.querySelector('#request_id').value = this.requestId;
  }

  setFormRequestId(form) {
    this.requestId = uuidv4();
    form.querySelector('#request_id').value = this.requestId;
  }

  setActionSource(actionSource) {
    document.querySelector('#action_source').value = actionSource;
  }

  replaceElementWithNewBySingleQuery(query, event) {
    let newElement = event.detail[0].body.querySelector(query);
    let oldElement = document.querySelector(query);
    oldElement.parentElement.replaceChild(newElement, oldElement);
  }

  beforeReflex(element, reflex, noop, reflexId) {
    this.appendLog("before");
  }
  reflexSuccess(element, reflex, noop, reflexId) {
    this.appendLog("success");
    this.showTimesAndDatesInLocalZone();
  }
  reflexError(element, reflex, error, reflexId) {
    this.appendLog(error);
  }
  reflexHalted(element, reflex, noop, reflexId) {
    this.appendLog("halted");
  }
  afterReflex(element, reflex, noop, reflexId) {
    this.appendLog("after");
  }
  finalizeReflex(element, reflex, noop, reflexId) {
    this.appendLog("finalize");
  }

  capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  toCamelCase(text, delimiter = '_', includeFirstWord = false) {
    return text.split(delimiter).map((word, index) => {
      if (index === 0 ) {
        if (includeFirstWord) {
          return word.toLowerCase();
        } else {
          return word;
        }
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
}

  createSpinnerElement() {
    let spinnerWrapper = document.createElement('div')
    spinnerWrapper.classList.toggle('spinner-border');
    return spinnerWrapper;
  }

  spinnerOn(element = null) {
    if (!document.body.classList.contains('loading')) {
      document.body.classList.toggle('loading');
    }
    if (element == null) {
      var spinnerWrapper = document.querySelector('#spinner');
    } else {
      var spinnerWrapper = element;
    }
    if (spinnerWrapper) {
      if (!spinnerWrapper.classList.contains('spinner-border')) {
        spinnerWrapper.classList.toggle('spinner-border');
      }
    } else {
      this.appendLog('Missing div for spinner!')
    }
  }

  spinnerOff(element = null) {
    if (document.body.classList.contains('loading')) {
      document.body.classList.toggle('loading');
    }

    if (element == null) {
      var spinnerWrapper = document.querySelector('#spinner');
    } else {
      var spinnerWrapper = element;
    }
    if (spinnerWrapper) {
      if (spinnerWrapper.classList.contains('spinner-border')) {
        spinnerWrapper.classList.toggle('spinner-border');
      }
    } else {
      this.appendLog('Missing div for spinner!')
    }
  }

  showTimesAndDatesInLocalZone(element = null) {
    if (element == null) {
      element = document
    }
    element.querySelectorAll('[data-timestamp]').forEach(this.timeInLocalZone);
  }

  timeInLocalZone(element) {
    let dateTimeFrom = new Date(element.dataset.timestamp);
    let elementWithDate = element.querySelector('#date')
    let elementWithTime = element.querySelector('#time')
    if (elementWithDate != null) {
      elementWithDate.textContent = dateTimeFrom.toLocaleDateString(navigator.language);
    }
    if (elementWithTime != null) {
      elementWithTime.textContent = dateTimeFrom.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    }
  }

  scrollToStart(query, offset = 0) {
    const element = document.querySelector(query);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }
  }

  pushQueryParamsToUrl(form) {
    const url = new URL(window.location.href)
    const formData = new FormData(form)
    formData.delete('request[id]');
    formData.delete('request_id');
    const searchParams = new URLSearchParams(formData)
    url.search = searchParams.toString()
    window.history.pushState({}, '', url.toString())
  }

  addDocumentListener(event, callback) {
    document.addEventListener(event, callback);
    this.listeners.push({ event, callback });
  }

  removeDocumentListeners() {
    if (!this.listeners) return;

    this.listeners.forEach(({ event, callback }) => {
      document.removeEventListener(event, callback);
    });
    this.listeners = [];
  }

  showOverlay() {
    const overlay = document.createElement('div');
    overlay.id = 'error-overlay';
    overlay.classList.add('modal', 'modal--error');

    overlay.innerHTML = `
      <div id='spinner' class="spinner-border"></div>
    `;

    document.body.appendChild(overlay);
    this.spinnerOn();
  }

  showErrorOverlay(message, options = {}) {
    const { title = 'Chyba', requestId = null } = options;
    document.getElementById('error-overlay')?.remove();

    const modal = document.createElement('div');
    modal.id = 'error-overlay';
    modal.classList.add('modal', 'modal--error');

    modal.innerHTML = `
      <div class="modal-dialog">
        <div class="header">
          <h4 class="bold">${title}</h4>
          <a href="#" class="icon-close" id="error-overlay-close"></a>
        </div>
        <p>${message}</p>
        ${requestId ? `<p class="error-request-id"><code>${requestId}</code></p>` : ''}
      </div>
    `;

      modal.querySelector('#error-overlay-close').addEventListener('click', (e) => {
      e.preventDefault();
      this.closeErrorOverlay();
    });
    modal.addEventListener("keydown", evt => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
        isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
        this.closeErrorOverlay();
      }
    });

    document.body.appendChild(modal);
  }

  closeErrorOverlay() {
    document.getElementById('error-overlay')?.remove();
  }

  _handleErrorMessage(event) {
    const { message, title, requestId } = event.detail;
    this.showErrorOverlay(message, { title, requestId });
  }
}
